module.exports = __webpack_public_path__ + "static/media/laugh-squint.97ddf99f.svg";